export const MORT_PERSONAL_AREA_TITLE = `מה תמצאו באיזור האישי שלכם?`;